type PermissionAction = "Read" | "Edit" | "Delete";

interface ModulePermission {
  name?: string;
  permissions?: string[];
}

interface PermissionUserDetails {
  role_char?: string;
  permissions?: ModulePermission[];
}

export const hasModulePermission = (
  userDetails: PermissionUserDetails | undefined,
  moduleName: string,
  action: PermissionAction,
): boolean => {
  if (userDetails?.role_char === "Admin") return true;
  const target = moduleName.toUpperCase().trim();
  return (userDetails?.permissions || []).some(
    (item) =>
      item.name?.toUpperCase().trim() === target &&
      Boolean(item.permissions?.includes(action)),
  );
};
